$(document).ready(function() {
  if($(".slider, .slider2").length) {    
    $(".slider, .slider2").slick({
      dots: !0,
      autoplaySpeed: 6000,
      autoplay: !0,
      fade: !0
    });
  }
  
  if($(".slider--fade").length) {
    $(".slider--fade").slick({
      dots: !0,
      autoplay: !0,
      fade: !0
    });
  }

  updateDataEqualizer(false);
  $(window).resize(function(){
    updateDataEqualizer(true);
  });
});

function updateDataEqualizer(reset) {
  console.log('updateDataEqualizer')
  $('.row[data-equalizer]').each(function() {
    if(reset) {
      $(this).find('[data-equalizer-watch]').each(function() {
        $(this).css('height','auto');
      });
    }
    var height = 0;
    $(this).find('[data-equalizer-watch]').each(function() {
      if($(this).innerHeight() > height) height = $(this).innerHeight();
    });
    $(this).find('[data-equalizer-watch]').each(function() {
      $(this).css('height',height+'px');
    });
  });
}